<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path stroke="#000" d="M15.5 15.5L21 21"/>
  <circle cx="10.5" cy="10.5" r="7.5" stroke="#000"/>
</svg>
